import React from 'react'

import { FormattedHTMLMessage } from '@web/walter-ui-kit'
import styles from './style.module.css'
import { lang } from './lang'
import SwapWidgetPreloader from '~components/SwapWidget/Preloader'
import PageHeader from '~components/PageLayout/PageHeader'
import PageLayout from '~components/PageLayout'

function Preloader() {
    return (
        <PageLayout contentWidth="m" header={<PageHeader rootPage title={<FormattedHTMLMessage {...lang.header} />} />}>
            <div className={styles.wrap} data-pointer="swap_page_preloader">
                <SwapWidgetPreloader />
            </div>
        </PageLayout>
    )
}

export default Preloader
